<template>
  <div class="tablePage">
    <!-- 表格-->
    <v-table
      is-horizontal-resize
      style="width:100%"
      :columns="tableConfig.columns"
      :table-data="tableData"
      :paging-index="(pageIndex-1)*pageSize"
      :cell-edit-done="cellEditDone"
      :column-cell-class-name="columnCellClass"
      @on-custom-comp="customCompFunc"
    ></v-table>
  </div>
</template>
<script>
import Vue from 'vue'
export default {
  data () {
    return {
      pageIndex: 1,
      pageSize: 10,
      total: '',
      tableConfig: {
        columns: [
      {field: 'workTime', title:'日期', width:100,isResize:true,height:66, titleAlign: 'center',columnAlign:'center',isEdit:true, componentName:'test',
      formatter: function (rowData,rowIndex,pagingIndex,field) {
               return `<span class='cell-edit-color'>${rowData[field]}</span>`;
           }
           },

        ]
      }
    }
  },
  props:['tableWidth','tableData','workTypeDict','comfirmFlag'],
  mounted () {
    this.initColumns();
  },
  methods: {
    initColumns:function(){
      let that = this;
      that.workTypeDict.forEach(dict=>{
        that.tableConfig.columns.push({
          field: dict.code,
          title: dict.name,

          height:66,
          width:50,
          isResize:true,
          titleAlign: 'center',
          columnAlign:'center',
          isEdit:that.tableWidth.isEdit
        })
      })
      console.log(that.tableConfig.columns)
    },

     columnCellClass(rowIndex,columnName,rowData){
      if (rowData.az>0&&columnName=='az'){
          return 'bg-gray';
      }
      if (rowData.by>0&&columnName=='by'){
          return 'bg-gray';
      }
      if (rowData.wx>0&&columnName=='wx'){
          return 'bg-gray';
      }
      if (rowData.bq>0&&columnName=='bq'){
          return 'bg-gray';
      }
    },

   // 单元格编辑
   cellEditDone(newValue,oldValue,rowIndex,rowData,field){
     let that = this;
     if(field=='workTime'){
       // if(rowIndex==0){
       //   that.tableData[rowIndex][field] = newValue;
       //   that.$emit("getSonTable", {index:rowIndex,value:newValue,isdate:true});
       // }
     }else{
        if(newValue){
          that.tableData[rowIndex][field] = parseInt(newValue);
        }else{
          that.tableData[rowIndex][field] =0
        }
      that.$emit("getSonTable", that.tableData);
     }
    },
    customCompFunc(params){
        let that = this;
        that.$emit("getSonTable", {index:params.index,value:params.rowData.workTime,isdate:true});
      }
    }

  };
  // 自定义列组件
  Vue.component('test',{
      template:`<el-date-picker v-model="rowData.workTime" type="date" size="medium" value-format="yyyy-MM-dd"
                  placeholder="选择日期" :picker-options="pickerOptions0" @change="changeTableDate">
                </el-date-picker>`,
      data:function(){
          return {
                //日期可选择范围为 当前使时间之后
                pickerOptions0: {
                  disabledDate(time) {
                    return time.getTime() <= new Date().getTime() - 86400000;
                  }
                }
              }
            },
      props:{
        rowData:{
            type:Object
        },
        field:{
            type:String
        },
        index:{
            type:Number
        }
      },
      methods:{
          changeTableDate() {
            let that=this
            let params = {type:'edit',index:that.index,rowData:that.rowData,isFrist:1};
            that.$emit('on-custom-comp',params);
          }
      }
  })
</script>
<style lang="scss">
  .v-table-row{
    .el-input__inner{
      border: none;
    }
    .el-input--prefix .el-input__inner{
     padding-left: 34px;
    }
  }
  .tablePage ::v-deep .bg-gray{
    background: rgba(237,239,242,1);
  }
</style>
